import { CrmJobDTO } from '../..';
import axios from '../../../axios';
import { CrmJobFilterDTO } from '../types/CrmJobFilterDTO';
import CrmJobStatusDTO from '../types/CrmJobStatusDTO';

const url = '/invoicingservice/api/crm/jobs';

export const getCrmJobById = (id: string, includeContacts?: boolean) => {
  const params = includeContacts !== undefined ? { includeContacts } : undefined;
  return axios.get(`${url}/${id}`, params ? { params } : undefined);
};

export const createCrmJob = (crmJob: CrmJobDTO) => axios.post(`${url}/save`, crmJob);

export const updateCrmJob = (crmJob: CrmJobDTO) => axios.put(`${url}/update`, crmJob);

export const getAllCrmJobs = (crmJobFilterDTO: CrmJobFilterDTO) =>
  axios.post(`${url}/list`, crmJobFilterDTO);

export const downloadCrmJobs = (crmJobFilterDTO: CrmJobFilterDTO, type: string) =>
  axios.post(`${url}/download/${type}`, crmJobFilterDTO, {
    responseType: 'arraybuffer',
  });

export const getEligibleContacts = (jobId: string) =>
  axios.get(`${url}/${jobId}/eligible-contacts`);

export const getTaggedContacts = (jobId: string) => axios.get(`${url}/${jobId}/tagged-contacts`);

export const tagContact = (jobId: string, contactId: string) =>
  axios.post(`${url}/${jobId}/tag-contact`, contactId);

export const untagContact = (jobId: string, contactId: string) =>
  axios.delete(`${url}/${jobId}/tag-contact/${contactId}`);

export const bulkTagContacts = (crmJobFilterDTO: CrmJobFilterDTO) =>
  axios.post(`${url}/bulk-tag-contacts`, crmJobFilterDTO);

export const resetAllMailingLists = () => axios.delete(`${url}/reset-all-mailing-lists`);

export const bulkAssignJobOwner = (crmJobFilterDTO: CrmJobFilterDTO) =>
  axios.post(`${url}/bulk-assign-owner`, crmJobFilterDTO);

export const saveCrmJobStatus = (crmJobStatus: CrmJobStatusDTO) =>
  axios.post(`${url}/create-status`, crmJobStatus);

export const getCrmJobStatusList = () => axios.get(`${url}/status/list`);
